import toast, { ToastOptions } from 'react-hot-toast'

type ToastOpts = Partial<ToastOptions>

export const showToast = {
  success: (message: string, options?: ToastOpts) => {
    return toast.success(message, {
      duration: 3000,
      position: 'top-right',
      ...options,
    })
  },

  error: (message: string, options?: ToastOpts) => {
    return toast.error(message, {
      duration: 4000,
      position: 'top-right',
      ...options,
    })
  },

  warning: (message: string, options?: ToastOpts) => {
    return toast(message, {
      duration: 3500,
      position: 'top-right',
      icon: '⚠️',
      ...options,
    })
  },

  info: (message: string, options?: ToastOpts) => {
    return toast(message, {
      duration: 3000,
      position: 'top-right',
      icon: 'ℹ️',
      ...options,
    })
  },

  loading: (message: string, options?: ToastOpts) => {
    return toast.loading(message, {
      position: 'top-right',
      ...options,
    })
  },

  dismiss: (toastId?: string) => {
    toast.dismiss(toastId)
  },
}

// Re-export toast for advanced usage (e.g., toast.custom, accessing t.id in callbacks)
export { toast }
